// must be first
import './polyfills'

import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { TrackingEventType } from '@ftr/foundation'
import { WindowConfig, WindowRef } from '@ftr/window'
import { AdminAppModule } from '~admin/admin-app.module'
import { environment } from '~admin/environments/environment'

if (environment.production) {
  enableProdMode()
}
/**
 * If we are in a production environment, we need to bootstrap angular config variables are loaded.
 * process.env.CONFIG is set in the webpack config.
 * This script contains things like our logging url etc.
 */

const ref = window as unknown as WindowRef
ref.config = process.env.CONFIG as unknown as WindowConfig

enableTracking()
enableNewRelicMonitoring()
platformBrowserDynamic()
  .bootstrapModule(AdminAppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err))
/**
 * Google tag manager tracking script, just done in body, rather than head, due to needing the config
 */
function enableTracking(): void {
  const windowRef = window as unknown as WindowRef
  if (!windowRef.dataLayer) {
    windowRef.dataLayer = [{ 'gtm.start': new Date().getTime(), event: 'gtm.js' as TrackingEventType }]
    const script = document.createElement('script')
    script.async = true
    const config = windowRef.config || environment.config
    script.src = `https://www.googletagmanager.com/gtm.js?id=${config?.TrackingContainerCode || 'GTM-M73SKXB'}`
    document.body.appendChild(script)
  }
}
function enableNewRelicMonitoring(): void {
  const windowRef = window as unknown as WindowRef
  if (windowRef.config?.NewRelicWebAppId) {
    const newrelicScript = document.createElement('script')
    newrelicScript.src = '/newrelic.js'
    document.head.appendChild(newrelicScript)
  }
}
